import React, { useState } from 'react';
import api from '../../../../config/axios';
import Swal from 'sweetalert2';
import { FaTimes, FaFilePdf } from 'react-icons/fa';
import DatePicker from '../../../../components/utils/datepicker';
import moment from 'moment';

const GerarRelatorio = ({ contasBancarias, onClose }) => {
    const [contaBancariaId, setContaBancariaId] = useState('');
    const [dataInicio, setDataInicio] = useState(null);
    const [dataFim, setDataFim] = useState(null);
    const [gerando, setGerando] = useState(false);

    const handleGerarRelatorio = async () => {
        if (!contaBancariaId) {
            Swal.fire('Atenção', 'Selecione uma conta bancária', 'warning');
            return;
        }

        if (!dataInicio || !dataFim) {
            Swal.fire('Atenção', 'Selecione o período', 'warning');
            return;
        }

        if (moment(dataInicio).isAfter(moment(dataFim))) {
            Swal.fire('Atenção', 'A data inicial não pode ser maior que a data final', 'warning');
            return;
        }

        setGerando(true);

        try {
            Swal.fire({
                title: 'Gerando relatório...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const params = {
                conta_bancaria_id: contaBancariaId,
                data_inicio: moment(dataInicio).format('YYYY-MM-DD'),
                data_fim: moment(dataFim).format('YYYY-MM-DD')
            };

            const baseUrl = api.defaults.baseURL || '';
            const token = localStorage.getItem('token');
            const apiKey = api.defaults.headers?.['x-api-key'] || '';

            const queryString = new URLSearchParams(params).toString();
            const pdfUrl = `${baseUrl}/conciliacao/relatorio?${queryString}`;

            const response = await fetch(pdfUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'x-api-key': apiKey
                }
            });

            if (!response.ok) {
                const error = await response.json().catch(() => ({}));
                throw new Error(error.message || 'Erro ao gerar relatório');
            }

            const arrayBuffer = await response.arrayBuffer();
            const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');

            Swal.close();
        } catch (error) {
            Swal.fire('Erro', error.message || 'Erro ao gerar relatório. Tente novamente.', 'error');
        } finally {
            setGerando(false);
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">Gerar Relatório</h4>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label className="form-label fw-bold">Conta Bancária</label>
                            <select
                                className="form-select"
                                value={contaBancariaId}
                                onChange={(e) => setContaBancariaId(e.target.value)}
                            >
                                <option value="">Selecione uma conta</option>
                                {contasBancarias.map(conta => (
                                    <option key={conta.id} value={conta.id}>
                                        {conta.nome_exibicao || conta.nome} {conta.banco?.nome ? `- ${conta.banco.nome}` : ''}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-bold">Período De</label>
                            <DatePicker
                                selected={dataInicio}
                                onChange={(date) => setDataInicio(date)}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label fw-bold">Período Até</label>
                            <DatePicker
                                selected={dataFim}
                                onChange={(date) => setDataFim(date)}
                            />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-danger" onClick={onClose}>
                            <FaTimes className="me-1" />
                            Fechar
                        </button>
                        <button
                            type="button"
                            className="btn btn-custom-primary"
                            onClick={handleGerarRelatorio}
                            disabled={gerando}
                        >
                            <FaFilePdf className="me-1" />
                            {gerando ? 'Gerando...' : 'Gerar PDF'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GerarRelatorio;
